import React, { useState, useEffect } from 'react';

const BtnScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Mostrar el botón cuando el usuario hace scroll hacia abajo
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  if (typeof window === 'undefined') {
    return null; // Asegurarse de que no se renderice en el lado del servidor (si aplica)
  }

  return (
    <>
      {isVisible && (
        <a 
          href="#!" 
          className="scroll-to-top" 
          onClick={scrollToTop}
          style={{ zIndex: 9999 }}
        >
          <i className="fas fa-angle-up" aria-hidden="true"></i>
        </a>
      )}
    </>
  );
};

export default BtnScrollToTop;

